import React, { useEffect, useState } from 'react';
import ChatSuggestionCard from '../chat/ChatSuggestionCard';
import './SaenggibuSuggestionCard.css';

const SaenggibuSuggestionCard = ({
  suggestion,
  result = null,
  busy = false,
  onAction,
  resolvedLabel,
}) => {
  const options = Array.isArray(suggestion?.options) ? suggestion.options.slice(0, 2) : [];
  const defaultOptionId = suggestion?.default_option || options[0]?.id || '';
  const [selectedOption, setSelectedOption] = useState(defaultOptionId);

  useEffect(() => {
    setSelectedOption(defaultOptionId);
  }, [defaultOptionId]);

  if (!suggestion || result) return null;

  const handleAction = (action, nextSuggestion) => {
    if (busy || typeof onAction !== 'function') return;
    onAction(action, nextSuggestion, { option: selectedOption || undefined });
  };

  return (
    <div className="saenggibu-suggestion-card" data-testid="saenggibu-suggestion-card">
      <ChatSuggestionCard
        suggestion={suggestion}
        busy={busy}
        onAction={handleAction}
        resolvedLabel={resolvedLabel}
        beforeActions={options.length > 1 ? (
          <div className="saenggibu-suggestion-options" role="group" aria-label="적용 범위">
            {options.map((option) => {
              const selected = selectedOption === option.id;
              return (
                <button
                  key={option.id}
                  type="button"
                  aria-pressed={selected}
                  className={`saenggibu-suggestion-option${selected ? ' is-selected' : ''}`}
                  disabled={busy}
                  onClick={() => setSelectedOption(option.id)}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        ) : null}
      />
    </div>
  );
};

export default SaenggibuSuggestionCard;
